<script>
import { mapGetters, mapActions } from "vuex";
import login from "@/api/login";

export default {
	name: "login",
	data () {
		return {
			errorMessage:""
		};
	},
	computed: {
		...mapGetters("session", ["username"])
	},
	methods: {
		...mapActions("session", ["setUsername", "setUserLoggedIn"]),
		tryLogin() {
			const password = document.getElementById("passwordInputField").value;
			if(!this.username){
				return this.errorMessage = "* Username is empty";
			} else if(!password) {
				return this.errorMessage = "* Password is empty";
			}
			return login(
				{
					username: this.username,
					password: password
				})
				.then(() => {
					this.errorMessage = "";
					this.setUserLoggedIn();
					this.$router.replace({ name: "status" });
				})
				.catch(err => {
					if(err.status === 401){
						this.errorMessage = "* Wrong username or password, Please try again";
					} else
						this.errorMessage = err.error;
				});
		},
	},
	mounted() {
		if (this.$route.query.username) {
			this.setUsername(this.$route.query.username);
		}
	}
};
</script>

<template>
	<v-app id="inspire">
		<v-main>
			<v-container fluid fill-height>
				<v-layout align-center justify-center>
					<v-flex xs12 sm8 md5>
						<v-card class="elevation-12 box">
							<div class="left-side">
								<h1 class="z-title">Login</h1>

								<v-form @submit.prevent ="tryLogin">
									<v-text-field
										:value="username"
										@input="setUsername"
										label="Username"
										prepend-inner-icon="person"
										outlined
										type="text"
										required
										autofocus
									/>
									<v-text-field
										label="Password"
										prepend-inner-icon="lock"
										outlined
										type="password"
										@keyup.enter="tryLogin"
										id="passwordInputField"
									/>
								</v-form>

								<v-btn
									block
									large
									type ="submit"
									color="primary"
									@click="tryLogin()"
								>
									Login
								</v-btn>

								<div>{{errorMessage}}</div>

								<router-link
									:to="{name: 'resetPassword'}"
									color="primary"
								>
									Forgot username or password?
								</router-link>

							</div>
							<div class="right-side d-none d-sm-flex">
								<div>
									<img
										src="../../../static/z-logo.png"
										alt=""
										width="80%"
									/>
								</div>
							</div>
						</v-card>
					</v-flex>
				</v-layout>
			</v-container>
		</v-main>
	</v-app>
</template>

<style lang="scss" scoped>
.v-main {
	background-color: rgba(10, 10, 10, 0.86);
}
.box {
	display: flex;
	padding: 20px;
	.z-title {
		color: #1a1a1a;
		font-size: 48px;
		line-height: 1;
		font-weight: 300;
		word-break: break-word;
		margin-bottom: 10px;
	}
	.v-btn {
		text-transform: capitalize;
		font-size: 22px;
		font-weight: normal;
	}
	a {
		text-decoration: none;
	}
	.warningMessage {
		padding: 5px;
	}
	.left-side, .right-side {
		width: 50%;
		padding: 10px;
	}
	.right-side {
		text-align: center;
	}
	@media only screen and (max-width: 600px) {
		.left-side {
			width: 100%;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/views/Login.vue